import { IAjaxConfig } from '../helpers';
/**
 *  积分订单 API 地址
 *  @swagger http://bpportalordersit.earth.xpaas.lenovo.com/swagger-ui/index.html#/
 */
export class EnumApiPointsOrders {
  /**
   * @dec 搜索
   */
  readonly points_orders_list: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/managerIntegralShopOrder/order/search',
    method: 'post',
    loading: true,
  };

  /**
   * @dec 订单：取消订单
   */
  readonly points_order_cancel: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/managerIntegralShopOrder/order/cancelOrder',
    loading: true,
    method: 'post',
  };

  /**
   * @dec 订单详情-获取商品详情
   */
  readonly points_orders_details: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/managerIntegralShopOrder/order/allDetail',
    method: 'post',
  };

  /**
   * @dec 我的订单 查看物流信息接口
   */
  readonly points_order_getstockinfo: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/managerIntegralShopOrder/order/getStockInfo?orderId=',
    loading: true,
  };

  /**
   * @dec 我的订单 查看可收货列表
   */
  readonly points_order_getConfirmReceiptList: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/managerIntegralShopOrder/signDeliveryList?orderId=',
    loading: true,
  };

  /**
   * @dec 我的订单 确认收货
   */
  readonly points_order_confirmReceipt: IAjaxConfig = {
    url: '/api/bpportal-mall/bpportal-mall-order/managerIntegralShopOrder/signForDelivery',
    loading: true,
    method: 'post',
  };
}
